import { useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/router';

import getMenuTabs from '../MainLayout/helpers/menuTabs';

export const getDefaultMenuTabsPaths = (menuTabs) => menuTabs.reduce((acc, tab) => {
  const defaultPath = tab.paths[0];
  acc[tab.name] = defaultPath;

  return acc;
}, {});

export default function useUserTabs({ user, company }) {
  const router = useRouter();

  const menuTabs = useMemo(() => getMenuTabs(user, company), [company, user]);

  const [lastMenuTabsScreens, setLastMenuTabsScreens] = useState();

  useEffect(() => {
    setLastMenuTabsScreens(getDefaultMenuTabsPaths(menuTabs));
  }, [menuTabs]);

  useEffect(() => {
    const tab = menuTabs.find((item) => item.paths.includes(router.route));
    if (tab) {
      setLastMenuTabsScreens((old) => ({
        ...old,
        [tab.name]: router.asPath,
      }));
    }
  }, [router.route, router.asPath, menuTabs]);

  return {
    menuTabs,
    lastMenuTabsScreens,
  };
}
